import { render, staticRenderFns } from "./ChildUsers.vue?vue&type=template&id=28c3a6c6"
import script from "./ChildUsers.vue?vue&type=script&lang=js"
export * from "./ChildUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports